import { writable } from "svelte/store";

function createFreeCameraStore() {
    const { subscribe, set } = writable(false);

    return {
        subscribe,
        activate: () => set(true),
        deactivate: () => set(false),
    };
}

export const freeCameraStore = createFreeCameraStore();
